import React from 'react'
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton'
import '../../LookupsCommonStyles/LookupsTopContainerStyle.css'
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs'

function DesignationSearchFilter({ isAddPermission, tableTitle, isAddEditModalOpen, handleAddEditModal }) {

    const handleModal = () => {
        handleAddEditModal(!isAddEditModalOpen)
    }
    const breadcrumbs =['Settings', tableTitle]

    return (
        <div className='lookup-filter-container'>
            <div className='lookup-filter-sub-container'>
                <div className='technology-lookup-search-left'>
                    <div className="lookup-section-title">{tableTitle}</div>
                    <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div></div>
                    <div className='lookup-action-button-container'>
                        {isAddPermission && <CustomAddButton label={`Add`} onClick={handleModal} />}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default DesignationSearchFilter
